import React from 'react'
import { PoiPropertiesProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  PropertyGroup,
  Label,
  Input,
  TextArea,
  Select,
  FlexRow,
  RangeInput,
  RangeValue,
} from '../styled'

const PoiProperties: React.FC<PoiPropertiesProps> = ({
  selectedElement,
  localProperties,
  isCollapsed,
  onToggleSection,
  updateProperty,
}) => {
  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Point of Interest</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <PropertyGroup>
          <Label>Label/Name</Label>
          <Input
            value={localProperties.label || ''}
            onChange={e => updateProperty('label', e.target.value)}
            placeholder="e.g., Fire Extinguisher, Exit"
          />
        </PropertyGroup>
        <PropertyGroup>
          <Label>Description</Label>
          <TextArea
            value={localProperties.description || ''}
            onChange={e => updateProperty('description', e.target.value)}
            placeholder="Additional details..."
          />
        </PropertyGroup>
        <PropertyGroup>
          <Label>Category</Label>
          <Select
            value={localProperties.category || 'general'}
            onChange={e => updateProperty('category', e.target.value)}>
            <option value="safety">Safety Equipment</option>
            <option value="electrical">Electrical</option>
            <option value="plumbing">Plumbing</option>
            <option value="hvac">HVAC</option>
            <option value="security">Security</option>
            <option value="accessibility">Accessibility</option>
            <option value="furniture">Furniture</option>
            <option value="appliance">Appliances</option>
            <option value="general">General</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Size</Label>
          <FlexRow>
            <RangeInput
              min="10"
              max="50"
              value={localProperties.size || 20}
              onChange={e => updateProperty('size', Number(e.target.value))}
            />
            <RangeValue>{localProperties.size || 20}px</RangeValue>
          </FlexRow>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Priority</Label>
          <Select
            value={localProperties.priority || 'normal'}
            onChange={e => updateProperty('priority', e.target.value)}>
            <option value="high">High</option>
            <option value="normal">Normal</option>
            <option value="low">Low</option>
          </Select>
        </PropertyGroup>
      </SectionContent>
    </PropertySection>
  )
}

export { PoiProperties }
